import { DataTable } from '../../../../../components/UI/MDC/DataTable/DataTable';
import DeactivateAppSystem from './DeactivateAppSystem';
const WQSystemTable = ({
	systems,
	setAppSystems,
	appID,
	app,
	currentUser,
	requirementNumber,
	readOnly,
}) => {
	const headers = [
		{ Value: 'Actions', props: { sort: null, onSortChange: null } },
		{ Value: 'Name', props: { sort: null, onSortChange: null } },
		{ Value: 'ID', props: { sort: null, onSortChange: null } },
		{ Value: 'Order', props: { sort: null, onSortChange: null } },
		{ Value: 'Support Email', props: { sort: null, onSortChange: null } },
	];

	const rows = systems.map((system, index) => {
		return {
			Cells: {
				Actions: {
					Value: (
						<DeactivateAppSystem
							system={system}
							appID={appID}
							app={app}
							currentUser={currentUser}
							requirementNumber={requirementNumber}
							readOnly={readOnly}
							setAppSystems={setAppSystems}
						/>
					),
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				Name: {
					Value: system.Full,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				ID: {
					Value: system.Id,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				'Support Email': {
					Value: system.SupportEmail,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				Order: {
					Value: system.OrderBy,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
			},
			Key: system.ID,
		};
	});

	return <DataTable rows={rows} headers={headers} />;
};

export default WQSystemTable;
